/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowDownRhombus = createReactComponent("outline", "arrow-down-rhombus", "IconArrowDownRhombus", [["path", { "d": "M12 8v13", "key": "svg-0" }], ["path", { "d": "M15 18l-3 3l-3 -3", "key": "svg-1" }], ["path", { "d": "M14.5 5.5l-2.5 -2.5l-2.5 2.5l2.5 2.5z", "key": "svg-2" }]]);

export { IconArrowDownRhombus as default };
//# sourceMappingURL=IconArrowDownRhombus.mjs.map
